import {
  OptionGroup,
  OptionGroupPageQuery,
  OptionGroupResource,
  OptionGroupResourcePage,
  OptionGroupResourcePayload,
  OptionGroupsResourcePayload,
  PageOf
} from '@/models'

import axios, { withToken } from '../axios'

import {
  generateCreate,
  generateDelete,
  generateRead,
  generateReadPage,
  generateUpdate
} from '../crudGenerator'

/**
 * Converts OptionGroupResource to OptionGroup.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOptionGroupResource (resource: OptionGroupResource): OptionGroup {
  return {
    id: resource.id,
    title: resource.title,
    sequence: resource.sequence,
    maxLength: resource.maxlength, // Renaming
    isRequired: resource.required, // Renaming
    isActive: resource.active // Renaming
  }
}

/**
 * Converts OptionGroupResourcePage to PageOf<OptionGroup>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOptionGroupResourcePage (page: OptionGroupResourcePage): PageOf<OptionGroup> {
  return {
    elements: page.optionGroups.map(parseOptionGroupResource),
    total: page.count
  }
}

const url = '/menu'
const entity = 'option-groups'

export default {
  /**
   * Creates a new OptionGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param payload Data required to create it.
   */
  createOptionGroup: generateCreate<OptionGroup, OptionGroupResource, OptionGroupResourcePayload>(url, entity, parseOptionGroupResource),

  /**
   * Deletes an OptionGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id OptionGroup id to be deleted.
   */
  deleteOptionGroup: generateDelete(url, entity),

  /**
   * Gets an OptionGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id OptionGroup id to be fetched.
   */
  fetchOptionGroup: generateRead(url, entity, parseOptionGroupResource),

  /**
   * Gets a page of OptionGroups.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param query Query optionGroups.
   */
  fetchOptionGroupPage: generateReadPage<OptionGroup, OptionGroupResourcePage, OptionGroupPageQuery>(url, entity, parseOptionGroupResourcePage),

  /**
   * Updates an existing OptionGroup.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id OptionGroup id to be updated.
   * @param payload Data required to create it.
   */
  updateOptionGroup: generateUpdate<OptionGroup, OptionGroupResource, OptionGroupResourcePayload>(url, entity, parseOptionGroupResource),

  /**
   * Updates sequences of OptionGroups.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param itemGroupId ItemGroup id to be updated OptionGroup sequences.
   * @param payload Data required to create it.
   */
  async updateSequences (tokenV2: string, accountId: number, shopId: number, itemGroupId: number, payload: OptionGroupsResourcePayload[]) {
    const config = withToken(tokenV2)
    const body = {
      optionGroups: payload
    }

    const response = await axios.put<OptionGroupResourcePage>(
      `${url}/accounts/${accountId}/shops/${shopId}/${entity}/update-sequences?groupId=${itemGroupId}`,
      body,
      config
    )

    return parseOptionGroupResourcePage(response.data)
  }
}
